<template>
  <el-form ref="form" size="mini" label-position="top" :model="formData">
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item :label="$l('form_label_custName') || '客户公司名称'">
          <el-input v-model="formData.custName" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          :label="$l('form_label_businessLicense') || '客户公司税号'"
        >
          <el-input v-model="formData.businessLicense" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$l('form_label_region') || '所在国家'">
          <el-input v-model="formData.regionName" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="18">
        <el-form-item :label="$l('form_label_custAddress') || '客户经营地址'">
          <el-input v-model="formData.custAddress" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$l('form_label_contactMobile') || '客户联系电话'">
          <el-input v-model="formData.contactMobile" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$l('form_label_custShortName') || '客户简称'">
          <el-input v-model="formData.custShortName" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$l('form_label_customerBizType') || '客户类型'">
          <el-input v-model="formData.customerBizTypeName" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$l('form_label_customerType') || '客户性质'">
          <el-input v-model="formData.customerTypeName" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$l('form_label_sales') || '接待人员'">
          <el-input v-model="formData.salesName" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          :label="$l('form_label_riskAssessor') || '财务风险评估人'"
        >
          <el-input v-model="formData.riskAssessorName" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="18">
        <el-form-item :label="$l('form_label_dep') || '业务部门'">
          <el-input v-model="formData.depName" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          :label="$l('form_label_managerApproval') || '部门主管审批人'"
        >
          <el-input v-model="formData.managerApprovalByName" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$l('form_label_approver') || '审批负责人'">
          <el-input v-model="formData.approverName" readonly />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          :label="$l('form_label_customerBackground') || '客户背景调查'"
          style="margin-bottom: 0 !important"
        >
          <Editor v-model="formData.customerBackground" disabled />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import Editor from '@/views/digital/components/editor'
export default {
  components: { Editor },
  props: {
    formData: { type: Object, default: () => {} },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>
